import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/** A small rounded label, tinted in its color. */
export const Chip = memo(
  ({ text, color = aiColors.primary }: { text: string; color?: string }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          alignSelf: 'flex-start',
          borderRadius: rpx(999),
          paddingHorizontal: rpx(8),
          paddingVertical: rpx(2),
          backgroundColor: tint(color, 0.1),
        }}
      >
        <Typography.Text size={rpx(11)} color={color} bold numberOfLines={1}>
          {text}
        </Typography.Text>
      </View>
    );
  },
);
